import React from 'react';

import { DefaultContext } from '@apollo/client';

import {
  UsersNotificationSetting,
  useUpdateUserNotificationSettingsMutation,
  useUserNotificationSettingsQuery,
} from 'src/api';

import { useCurrentUser } from './useCurrentUser';

export const useCurrentUserNotificationSettings = () => {
  const { user, isUserLoading } = useCurrentUser();

  const { data, loading } = useUserNotificationSettingsQuery({
    variables: {
      where: { id: user?.id },
    },
    skip: !user?.id,
  });

  const [updateUserNotificationSettings] = useUpdateUserNotificationSettingsMutation();

  const notificationSettings = React.useMemo(() => {
    return data?.user?.notificationSettings || [];
  }, [data]);

  const updateNotificationSettings = React.useCallback(
    async (newSettings: UsersNotificationSetting[], context: DefaultContext) => {
      if (!user?.id) return;

      await updateUserNotificationSettings({
        variables: {
          where: { id: user.id },
          data: {
            notificationSettings: {
              set: newSettings,
            },
          },
        },
        context,
      });
    },
    [updateUserNotificationSettings, user?.id],
  );

  return {
    notificationSettings,
    updateNotificationSettings,
    isUserLoading,
    loading,
  };
};
